module.exports = __webpack_public_path__ + "media/images/sample_user-6b8c66704d6a2d11a210e9d0e4cdaa73.png";